import { useRequirementFieldPath } from '../../requirement';
import { useCurrentConditionIndex } from '../useCurrentConditionIndex';

export const useConditionFieldPath = () => {
  const requirement = useRequirementFieldPath();
  const index = useCurrentConditionIndex();
  return `${requirement}.searchCombo.searchQueries.${index}` as const;
};
